<template>
  <tr class="marketing-automation-list-item">
    <td>
      <app-toggle v-model="active"
                  @input="onStatusToggle"></app-toggle>
    </td>

    <td>
      {{ item.name }}
    </td>

    <td>
      {{ sentDate }}
    </td>

    <td>
      {{ lastEditDate }}
    </td>

    <td class="marketing-automation-list-item-actions">
      <marketing-automation-list-item-actions :item="item"
                                              @duplicated="emitDuplicated"
                                              @deleted="emitDeleted"
                                              @edited="emitEdited" />
    </td>

    <confirmation-modal :value="showingDeactiveateModal"
                        confirm-label="Confirmar"
                        @confirm="onDeactivationConfirm"
                        @cancel="cancelDeactivation">
      <span slot="heading">
        Desativar Fluxo de Automação?
      </span>
      <span>
        Ao desativar um fluxo de automação todos os clientes que estão executando o fluxo serão removidos do fluxo,
        você tem certeza que deseja realizar essa operação?
      </span>
    </confirmation-modal>
  </tr>
</template>

<script>
import EventBus from "@packages/event-bus";
import ConfirmationModal from "@components/ConfirmationModal";
import AppToggle from "@components/Toggle";
import MarketingAutomationListItemActions from "@components/modules/marketing/automation/list/item/actions/MarketingAutomationListItemActions";

export default {
  components: {
    MarketingAutomationListItemActions,
    AppToggle,
    ConfirmationModal,
  },
  data() {
    return {
      active: false,
      showingDeactiveateModal: false,
    };
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  created() {
    this.active = this.item.isActive;
  },

  computed: {
    creationDate() {
      return this.$date.format(this.item.creationDate);
    },
    sentDate() {
      return this.item.creationDate
        ? this.$date.formatDateAndHour(this.item.creationDate)
        : "-";
    },
    lastEditDate() {
      return this.item.lastUpdate
        ? this.$date.formatDateAndHour(this.item.lastUpdate)
        : "-";
    },
  },

  methods: {
    onDeactivationConfirm() {
      this.setAutomationStatus();
      this.closeDeactivateModal();
    },
    cancelDeactivation() {
      this.active = true;
      this.closeDeactivateModal();
    },
    openDeactivateModal() {
      this.showingDeactiveateModal = true;
    },
    closeDeactivateModal() {
      this.showingDeactiveateModal = false;
    },
    onStatusToggle(val) {
      if (!val) {
        this.openDeactivateModal();
      } else {
        this.setAutomationStatus();
      }
    },
    emitDuplicated() {
      this.$emit("duplicated");
    },
    emitDeleted() {
      this.$emit("deleted");
    },
    emitEdited() {
      this.$emit("edited");
    },
    async setAutomationStatus() {
      try {
        await this.$api.marketing.automation.flow.status({
          automationId: this.item.id,
          status: this.active,
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.active
            ? "Automação ativada com sucesso!"
            : "Automação desativada com sucesso!",
          timeout: 3000,
        });
      } catch (error) {
        this.active = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-automation-list-item {
  td {
    .help {
      color: $primary;
    }
  }

  .marketing-automation-list-item-actions {
    i {
      margin-right: 5px;
    }

    svg {
      color: #707070;
    }
  }
}
</style>
